import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import PythonService from "src/api/PythonService";
import Label from "src/views/dashboard/lavel_icon";
import Value from "src/views/dashboard/Value_icon";

const BarChart = (props) => {
  const [data, setApiData] = useState([]);
  const [ChartType, setChartType] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);

  const [showLegend, setShowLegend] = useState(false);
  const [showDataLabels, setShowDataLabels] = useState(false);

  useEffect(() => {
    var myVariable = props.prams.filterData;
   
    if(myVariable[props.prams.prams.kpiId]!=undefined){      
      setApiData({
        options: {
            chart: {
                type: "radialBar"
            },
            labels:myVariable[props.prams.prams.kpiId]['options']['labels'],
            plotOptions: {
                radialBar: {
                    dataLabels: {
                        name: {
                            show: showLegend,
                            fontSize: '16px',   
                            fontWeight: 500,
                            fontFamily:'gadugi',            
                            colors: ["#2C384AF2"]
                        },
                        value:{
                          show: showDataLabels,
                          fontSize: '16px',   
                          fontWeight: 500,
                          fontFamily:'gadugi',            
                          colors: ["#2C384AF2"]
                        }                          
                    },
                    endAngle: 90,
                    startAngle: -90
                }
            }
        },
        series: myVariable[props.prams.prams.kpiId]['series']
    });
      setChartType(myVariable[props.prams.prams.kpiId]['options']['chart']['type']);
    }
    setIsLoading(false);
  }, [props.params,showDataLabels,showLegend]);

  function toggleLegend() {
  
    setShowLegend(!showLegend);

  }
  
  function toggleDataLabels() {
    setShowDataLabels(!showDataLabels);

  }
  
  if (IsLoading) {
    return <>....</>;
  }
  if(props.prams.filterData[props.prams.prams.kpiId]!=undefined){   
  return (
      <div className='Polar'>
        <div className='row'>
          <div className='col-lg-10'>
            <div className='componentNameC'>{props.prams.prams.component}</div>
          </div>
          <div className='col-lg-2 '>
            <div class="btn-group component_action_button" role="group" aria-label="Basic example">
            <div onClick={toggleDataLabels}  style={{ marginRight: '5px' }}>
                <Value show={showDataLabels}/>
            </div>
                <div onClick={toggleLegend}  >
                  <Label show={showLegend}/>
                </div>
                
              </div>
            </div>
        </div>
        <div className="p-2 Polar1">
            <ReactApexChart options={data.options} series={data.series} type={ChartType} height='165%'/>
        </div>
      </div>
      );
  }else{
    return (
      <div className='Polar'>
        <div className='row'>
          <div className='col-lg-12'>
            <div className='componentNameC'>{props.prams.prams.component}</div>
          </div>
        </div>
        <div className="p-4 Polar1" style={{     
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        height: '100vh', // Optionally set a height to center vertically in the viewport
        color: '#85929E'}}>
          Data Not Found!
            
        </div>
      </div>
    );
  }
};

export default BarChart;
